function isElementInViewport(el) {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return (
    rect.bottom > 0 &&
    rect.top < (window.innerHeight || document.documentElement.clientHeight)
  );
}

const productForm = document.querySelector('.product-single');
const footerWrapper = document.querySelector('.footer-wrapper');
const addToCartBtn = document.querySelector('.product--add-to-cart-button');

function handleStickyButton() {
  const productFormVisible = isElementInViewport(productForm);
  const footerVisible = isElementInViewport(footerWrapper);

  if (!productFormVisible && !footerVisible) {
    addToCartBtn.classList.add('add-to-cart--sticky');
    
  } else {
    addToCartBtn.classList.remove('add-to-cart--sticky');
  }
}

window.addEventListener('scroll', handleStickyButton);
window.addEventListener('resize', handleStickyButton);
handleStickyButton();
